export const tenantAdminQueryKeys = {
  root: ['tenant-admin'],
  tenants: ['tenant-admin', 'tenants'],
  tenantDetail: (tenantId) => ['tenant-admin', 'tenant-detail', tenantId],
  tenantFeatures: (tenantId) => ['tenant-admin', 'tenant-features', tenantId],
  tenantModules: (tenantId) => ['tenant-admin', 'tenant-modules', tenantId],
  tenantUsage: (tenantId) => ['tenant-admin', 'tenant-usage', tenantId],
};
